export default "__VITE_ASSET__s19n4CHC__"